export default "__VITE_ASSET__hiiN0C0k__"